<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <div class="container">
      <div class="steps-content">
        <div class="general-form-wrap videos-info-wrap box-wrapper">
          <div class="videos-form-wrap">
            <div class="heading">
              <h2 class="form-title">Videos ( Up to 3 )</h2>
            </div>
            <p class="description">
              Youtube Or Vimeo Only
              <br class="header-info-wrapper">
                  (Add up to 12 total videos after profile is created)
              </br>
            </p>
            <div class="videos-list">
              <div
                class="video-detail"
                v-for="(video, index) in videoList"
                :key="index"
              >
                <a-row :gutter="32">
                  <a-col :sm="3">
                    <div class="title-info">Video {{ index + 1 }}</div>
                  </a-col>
                  <a-col :sm="4">
                    <a-input
                      v-model="video.videoDesc"
                      placeholder="Video Title"
                    />
                  </a-col>
                  <a-col :sm="9">
                    <a-input
                      v-model="video.videoUrl"
                      placeholder="Video Link"
                    />
                  </a-col>
                  <a-col :sm="7">
                    <div class="button-wrap">
                      <span
                        v-if="video.id !== null && video.videoDesc !== '' && video.videoUrl !== ''"
                      >
                        <a-popconfirm
                          title="Sure you want to delete this video?"
                          @confirm="removeVideo(video)"
                          ok-text="Yes"
                          cancel-text="No"
                        >
                          <a-button type="danger" icon="delete"
                            >Delete</a-button
                          >
                        </a-popconfirm>
                      </span>
                      <span v-if="video.id === null && video.videoDesc !== '' && video.videoUrl !== ''">
                        <a-button
                          type="primary"
                          icon="file-add"
                          class="save-button"
                          v-on:click="addNewVideo(video)"
                          >Save</a-button
                        >
                      </span>
                      <span v-if="video.id !== null && video.videoDesc !== '' && video.videoUrl !== ''">
                        <a-button
                          type="primary"
                          icon="file-add"
                          class="save-button"
                          v-on:click="editVideo(video)"
                          >Edit</a-button
                        >
                      </span>
                      <span
                        v-if="video.videoDesc !== '' && video.videoUrl !== ''"
                      >
                        <a-button type="primary" @click="showModal(index)"
                          >Preview</a-button
                        >
                      </span>
                    </div>
                  </a-col>
                </a-row>
                <VideoModal
                  :url="video.videoUrl"
                  :visible="visibleList[index] && visibleList[index].visible"
                  @onModalClose="closeModal"
                  v-if="videoList.length !== 1"
                />
              </div>
              <a-form-item>
                <a-button type="primary" @click="handleNextSubmit" class="next-button first-save-button">Save And Continue</a-button>
                <a-button type="primary" @click="handleStepSkip" class="next-button second-skip-button">Skip</a-button>
              </a-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoModal from "../Athlete/VideoInfo/VideoModal";
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const athleteRepository = RepositoryFactory.get("athlete");
const ATHLETE_STORE_KEY = "athleteStore"
const STORE_KEY = "playerStore";

export default {
  name: "VideoInfo",
  props: ["id"],
  components: {
    VideoModal
  },
  data() {
    return {
      datalength: 0,
      visibleList: [],
      videoList: [
        {
          id: null,
          videoDesc: "",
          videoUrl: ""
        }
      ]
    };
  },
  mounted() {
    this.getVideoList();
  },
  computed: {
    ...mapGetters({
      athleteVideos: `${ATHLETE_STORE_KEY}/athleteVideos`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`
    }),
    athleteId() {
      return this.id || this.$route.params.id
    }
  },
  methods: {
    validateForm() {
      return true
    },
    ...mapActions({
      addPlayerVideos: `${STORE_KEY}/addPlayerVideos`,
      setProfileData: `${STORE_KEY}/setViewProfileData`,
    }),
    async getVideoList() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, { athleteId: this.athleteId, limit: 3, page: 1})
      this.videoList = this.athleteVideos.length === 3 ? this.athleteVideos : [...this.athleteVideos,   {
          id: null,
          videoDesc: "",
          videoUrl: ""
        },
        {
           id: null,
           videoDesc: "",
           videoUrl: ""
         },
         {
            id: null,
            videoDesc: "",
            videoUrl: ""
          }
        ].splice(0, 3)
        this.visibleList = this.videoList.map(item => ({visible: false}))
    },
    addNewVideo(video) {
      let toSend = {
        atheleteMainProfileId: this.athleteId,
        videoDesc: video.videoDesc,
        videoUrl: video.videoUrl
      };
      athleteRepository
        .postPlayerVideos(toSend)
        .then(async response => {
          this.$message.success("Video added successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, { athleteId: this.athleteId, limit: 3 })
          if (this.athleteVideos.length === 3) {
            await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, { id: this.athleteId, registerPageCompleted: 5, slug: 'athlete', message: "Videos  Added to Profile" })
            await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, { id: this.athleteId })
          }
        }).catch(error => {
          this.$notification.error({
            message: "Error",
            description: "Please Input A Valid Link"
          })
        })
    },
    editVideo(video) {
      let toSend = {
        videoDesc: video.videoDesc,
        videoUrl: video.videoUrl
      };
      athleteRepository
        .editPlayerVideos(toSend, video.id)
        .then(async response => {
          this.$message.success("Video updated successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, { athleteId: this.athleteId, limit: 3, page: 1 })
        })
    },
    removeVideo(video) {
      athleteRepository
        .deletePlayerVideos(video.id, {slug: 'athletevideo'})
        .then(async response => {
          this.$message.success("Video deleted successfully!");
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, { athleteId: this.athleteId, limit: 3, page: 1 })
        })
    },
    async handleNextSubmit() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, { id: this.athleteId, registerPageCompleted: 5, slug: 'athlete' })
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, { id: this.athleteId })
      this.$emit("save", this.athlete.registerPageCompleted);
    },
    handleStepSkip() {
      this.$emit("save", 5)
    },
    showModal(index) {
      this.visibleList[index].visible = true;
    },
    closeModal() {
      for (let i = 0; i < this.videoList.length + 1; i++) {
        this.visibleList[i].visible = false;
      }
    }
  },
  watch: {
    athleteVideos(newVal, _) {
      this.videoList = newVal.length === 3 ? newVal : [...newVal,   {
          id: null,
          videoDesc: "",
          videoUrl: ""
        },
        {
           id: null,
           videoDesc: "",
           videoUrl: ""
         },
         {
            id: null,
            videoDesc: "",
            videoUrl: ""
          }
        ].splice(0, 3)
        this.visibleList = this.videoList.map(item => ({visible: false}))
    }
  }
};
</script>
<style lang="scss">
.videos-form-wrap {
  .heading {
    margin-bottom: 10px;
  }
  .description {
    font-size: 14px;
    font-weight: 400;
    color: #797979;
    margin-bottom: 40px !important;
  }
  .videos-list {
    .video-detail {
      margin-bottom: 20px;
      .title-info {
        font-size: 14px;
        text-transform: uppercase;
        line-height: 40px;
        font-weight: 500;
        color: #000000;
      }
      .button-wrap {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
